import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/lean-body-mass-calculator',
  component: () => import('../../routes/LeanBodyMassCalculator.svelte'),
  card: {
    id: 'lean-body-mass-calculator',
    title: 'Lean Body Mass Calculator',
    description: 'Calculate your Lean Body Mass (LBM) using the Boer, James, and Hume formulas. Estimate body fat percentage from your LBM.',
    icon: 'fitness_center',
    iconBgClass: 'bg-rose-50',
    iconTextClass: 'text-rose-600',
    href: '/lean-body-mass-calculator',
    category: 'Weight & Nutrition',
  },
  seo: {
    title: 'Lean Body Mass Calculator – Free LBM & Body Fat Estimator',
    description: 'Free lean body mass calculator using Boer, James, and Hume formulas. Enter your weight, height, and sex to estimate LBM and body fat percentage.',
  },
};

export default meta;
